import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';


const SupportModal = ({modal=false, toggleModal}) => {      
    return (
        <Modal isOpen={modal} toggle={toggleModal} size={"sm"}>
            <ModalHeader toggle={toggleModal}>
                Symphony Support
            </ModalHeader>
            <ModalBody className="bg-white">
                <div className="row">
                    <div className="col-12 text-center">
                        <b>Tom Baker</b><br/>
                        972-961-4798<br/>
                        <a className="text-primary" 
                            href="mailto:tom@comp21.biz"
                        >tom@comp21.biz</a>
                        <br/>
                        <a className="text-info" 
                            href="https://us02web.zoom.us/j/9722396890"
                        >Click Here for a Zoom meeting</a>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button className='btn btn-secondary' onClick={toggleModal}>Close</Button>
            </ModalFooter>
        </Modal>
    );
}
export default SupportModal;



// WEBPACK FOOTER //
// ./src/components/staffDashboard/SupportModal.js